import { useCorrectionDialogStore } from "./store";
import { HarvestCorrectionFlow } from "./harvest-correction-flow";
import { TestCorrectionFlow } from "./test-correction-flow";

// Mounted once at the app root. Opened imperatively via useCorrectionDialogStore.
export function TemplateCorrectionDialog() {
  const { open, domain, sourceRevisionId, title, preselectInstanceIds, close } =
    useCorrectionDialogStore();

  if (!open || domain === null || sourceRevisionId === null) return null;

  if (domain === "harvest") {
    return (
      <HarvestCorrectionFlow
        sourceRevisionId={sourceRevisionId}
        title={title ?? ""}
        preselectInstanceIds={preselectInstanceIds}
        onClose={close}
      />
    );
  }
  return (
    <TestCorrectionFlow
      sourceRevisionId={sourceRevisionId}
      title={title ?? ""}
      preselectInstanceIds={preselectInstanceIds}
      onClose={close}
    />
  );
}
